<script>

    export default {
        data() {
            return {
                loading: {
                    login: false,
                    logout: false
                }
            }
        },
        methods: {
            login() {
                let vm = this;
                vm.loading.login = true
                this.$store.state.errors.login.clear()

                let data = {
                    username: this.username,
                    password: this.password
                }

                this.$http.post('/login', data, {
                    headers: {
                        'X-XSRF-TOKEN': this.$store.state.xsrfToken,
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response) => {
                    if (response.data.id != undefined) {
                        if (response.data.id == ab.user.id) {
                            location.reload(true)
                            return
                        }

                        this.getLoggedInUser(response.data.id, response.data.token)
                    }

                    this.$store.commit("csrfToken", response.data.csrf_token);
                    this.$store.commit("xsrfToken", {token: this.getXsrfToken()});

                    $('#login-modal').modal('hide')
                    vm.loading.login = false

                }).catch((error) => {
                    vm.loading.login = false
                    this.$store.state.errors.login.add('other', this.getLoginErrorMessage(error.response.data))
                })
            },
            logout() {
                let vm = this;
                this.loading.logout = true
                this.$http.post("/logout", {}, {
                        headers: {
                            'X-XSRF-TOKEN': this.$store.state.xsrfToken,
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    }
                ).then((response) => {
                    this.$store.commit("loggedInUser", {user: null})
                    this.$store.commit("csrfToken", response.data.csrf_token);
                    this.$store.commit("xsrfToken", {token: this.getXsrfToken()})
                    this.$store.commit("configure", {configure: false})
                    vm.loading.logout = false
                }).catch((error) => {
                    vm.loading.logout = false
                })
            },
            register(dataObject) {
                let token = this.getXsrfToken()
                this.$http.post('/register', dataObject, {
                    headers: {
                        'X-XSRF-TOKEN': token,
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then((response) => {

                    if (response.data.id != undefined) {
                        this.getLoggedInUser(response.data.id, response.data.token)
                        this.loading.register = false
                    }
                }).catch((error) => {
                    let message = this.getRegisterErrorMessage(error.response.data)

                    if (typeof message === 'string') {
                        this.$store.state.errors.register.add('other', message)
                    } else {
                        this.$store.state.errors.register.addAll(message)
                    }
                })
            },
            getLoggedInUser(id, token) {
                this.$http.get(`${ab.apiUrl}/users/${id}`)
                    .then((response) => {
                        $(this.$store.state.loginModal).modal("hide")

                        response.data.item.token = token
                        this.$store.commit("loggedInUser", {user: response.data.item})

                    })
                    .catch((error) => {
                        this.$store.state.errors.login.add('other', "Please check your username and password and try again.")

                    })
            },
            getXsrfToken() {
                var cookies = document.cookie.split(';');
                var token = '';

                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i].split('=');
                    if ($.trim(cookie[0]) == 'XSRF-TOKEN') {
                        token = decodeURIComponent(cookie[1]);
                        break
                    }
                }

                return token;
            },
            checkIfEmailAvailable(email) {
                return this.$http.post('/register/available', {email: email}, {
                    headers: {
                        'X-XSRF-TOKEN': this.getXsrfToken(),
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });
            },
            getLoginErrorMessage(payload) {
                if (payload && payload.error && payload.error.prefix) {

                    switch(payload.error.prefix) {
                        case 'auth_login_wrong_username_or_password':
                        case 'auth_blocked':
                        case 'auth_login_throttle_reached':
                            return payload.error.message
                        case 'auth_requires_tow_factor_auth':
                            window.location.replace(`${ab.siteUrl}/2fa/validate`)
                            break
                        default:
                            return 'Please check your username and password and try again.'
                    }

                } else {
                    return 'Please check your username and password and try again.'
                }
            },
            getRegisterErrorMessage(payload) {
                if (payload.error && payload.error.statusCode && payload.error.statusCode === 429) {
                    return 'Too many register attempts. Please try again in 1 minute.'
                } else {
                    return payload
                }
            }
        }
    }
</script>
